/* eslint-disable */
import axios, { AxiosResponse } from 'axios';
import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles/style.module.scss';
import Footer from '../../layouts/footer';
import Button from '../../components/ui/button/Button';
import { useStore } from '../../store/store';
import { debounce } from 'lodash';
import { selectProducts } from 'core/store/billing/selectors';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { getLocalizedText } from 'core/utils/localized';
import { t } from '@web-solutions/module-localization';
import getLocale from '../../../localization/get-locale';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';

import { CheckGrayIcon } from 'src/onboarding/assets/icons/CheckGrayIcon';
import { GiftIcon } from 'src/onboarding/assets/icons/GiftIcon';
import Plans from './layouts/plans';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
// import { useHideOnScroll } from 'src/onboarding/hooks/useHideOnScroll';
// import { useBottomButtonVisibility } from 'src/onboarding/hooks/useBottomButtonVisible';

import card1 from '../../assets/images/paywallCard1.png';
import card2 from '../../assets/images/paywallCard2.png';
import card3 from '../../assets/images/paywallCard3.png';
import card4 from '../../assets/images/paywallCard4.png';
import card5 from '../../assets/images/paywallCard5.png';
import card6 from '../../assets/images/paywallCard6.png';
import card7 from '../../assets/images/paywallCard7.png';
import { AutoSlider } from 'src/onboarding/components/ui/AutoSlider/AutoSlider';
import { UserPayload, UserResponse } from 'src/onboarding/types/api';
import { EmailPopup } from 'src/onboarding/components/ui/email-popup/EmailPopup';
import { applyFoodzeeAuthTokens } from 'src/onboarding/helpers/applyFoodzeeAuthTokens';
import { useAnonymousUser } from 'src/onboarding/hooks/useAnonymousUser';

declare const gtag: Function;

const EMAIL_POPUP_KEY = 'email_popup_shown';

interface PlansRef {
  onPayment: () => void;
}

const Paywall = () => {
  const dispatch = useDispatch();
  const locale = getLocale();
  const childRef = useRef<PlansRef>(null);
  const pageRef = useRef(null);
  const state = useStore((state) => state);
  const setPage = useStore((state) => state.setPage);

  const { email, savedOnboarding, setSavedOnboarding, existTimeoutId, setUserId, userId } = state;

  const productsObj = useSelector(selectProducts);
  const {
    // products,
    routeGroups: flow,
    paywall,
    showEmailPopup,
    paymentSystem,
  } = useRemoteConfig();

  // Deferred-email flow: create the anonymous user (email = null) as soon as the
  // user lands on the paywall, so checkout needs no email. No-op unless
  // `collectEmailAfterPayment` is enabled and the payment system is Stripe or
  // truegate.
  useAnonymousUser();

  const [showDownSaleModalOnce, setShowDownSaleModalOnce] = useState(false);
  const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(
    showEmailPopup && !email && !userId
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

//   useEffect(() => {
//     if (isEmailPopupOpen) {
//       const scrollY = window.scrollY;

//       document.body.style.position = 'fixed';
//       document.body.style.top = `-${scrollY}px`;
//       document.body.style.left = '0';
//       document.body.style.right = '0';
//       document.body.style.width = '100%';

//       return () => {
//         document.body.style.position = '';
//         document.body.style.top = '';
//         document.body.style.left = '';
//         document.body.style.right = '';
//         document.body.style.width = '';

//         window.scrollTo(0, scrollY);
//       };
//     }
//   }, [isEmailPopupOpen]);

  useEffect(() => {
    if (showEmailPopup && !email && !userId) {
      setIsEmailPopupOpen(true);
    }
  }, [email, showEmailPopup, userId]);

  const handleEmailPopupClose = () => {
    setIsEmailPopupOpen(false);
    sessionStorage.setItem(EMAIL_POPUP_KEY, 'true');
  };

  const { apiBaseUrl } = getEnvUrl();

  useEffect(() => {
    gtag('event', 'conversion', {
      send_to: 'AW-17149973324/gwbSCMu_yP0aEMym3_E_',
      value: 1.5,
      currency: 'USD',
    });
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(existTimeoutId);
    };
  }, [existTimeoutId]);

  const images = [card1, card2, card3, card4, card5, card6, card7];

  const productDescription = {
    //@ts-ignore
    name: paywall.product?.name,
    // plan_end_days: addDaysToDate(paywall.product?.priceStartTrial.plan_end_days),
    //@ts-ignore
    subTitle: paywall.product?.subTitle[locale],
    //@ts-ignore
    title: paywall.product?.title[locale],
    //@ts-ignore
    price: paywall.product?.priceStartTrial.price[locale],
    //@ts-ignore
    trialPrice: paywall.product?.trialPrice,
    //@ts-ignore
    afterTrial: paywall.product?.afterTrialText[locale],
  };
  const { name, subTitle, title, price, trialPrice, afterTrial } = productDescription;

  const targetRef = useRef(null);

  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const payment = () => {
    if (showEmailPopup && !email && !userId) {
      sessionStorage.removeItem(EMAIL_POPUP_KEY);
      setIsEmailPopupOpen(true);
      return;
    }

    childRef.current.onPayment();
  };

  const setOnboardingData = useCallback(
    debounce(async () => {
      try {
        const payload: UserPayload = {
          email,
        };

        const response: AxiosResponse<UserResponse> = await axios.post(
          `${apiBaseUrl}/v2/user`,
          payload
        );

        if (response.status === 201) {
          const filteredState = Object.fromEntries(
            Object.entries({ ...state }).filter(
              ([key, value]) => typeof value !== 'function' && key !== 'faceScanBase64'
            )
          );

          setUserId(response.data.uid);
          applyFoodzeeAuthTokens(response.data, dispatch, { reinitBilling: true, paymentSystem });

          await axios.post(`${apiBaseUrl}/onboarding`, {
            json: JSON.stringify(filteredState),
            user_id: response.data.uid,
          });
        }

        setSavedOnboarding(true);
      } catch (error) {
        // need change
        setSavedOnboarding(true);
        console.error('Error:', error);
      }
    }, 500),
    [email, state]
  );

  useEffect(() => {
    if (showEmailPopup && isEmailPopupOpen) {
      return;
    }

    if (!savedOnboarding && !showEmailPopup) {
      setOnboardingData();
    }
    return () => {
      setOnboardingData.cancel();
    };
  }, [setOnboardingData, savedOnboarding, showEmailPopup, isEmailPopupOpen]);

  const formatPriceInText = (text, priceAmount) => {
    if (!text || !priceAmount) return text;

    return text.replace(/\$\d+\.\d{2}/g, `$${priceAmount}`);
  };

  return (
    <>
      <div className={styles.page} ref={pageRef}>
        <AutoSlider images={images} title={getLocalizedText(paywall.title, locale)} />
        <div className={styles.options}>
          {paywall.options.map((option, index) => (
            <Text size='m' bold key={index} className={styles.option}>
              <CheckGrayIcon /> {getLocalizedText(option, locale)}
            </Text>
          ))}
        </div>
        <div className={styles.trial}>
          <GiftIcon />
          <p className={styles.options}>{title}</p>
        </div>
        <div className={styles.price}>
          <p className={styles.trialPrice}>{trialPrice}</p>
        </div>
      </div>
      <div className={styles.footer}>
        <Plans
          ref={childRef}
          showDownSaleModalOnce={showDownSaleModalOnce}
          setShowDownSaleModalOnce={setShowDownSaleModalOnce}
          scrollToTarget={scrollToTarget}
        />
        {/* <span className={styles.privacy}>
                      {t('onboarding.personalPlan.plan.accept')}{' '}
                      <a onClick={() => setPage('privacy-policy')}>
                        {t('onboarding.personalPlan.plan.privacy')}
                      </a>
                      , <a onClick={() => setPage('terms-of-use')}>{t('onboarding.personalPlan.plan.terms')}</a>
                    </span>
                    {showPlanDescription && (
                      <span className={styles.privacy}>
                        {t('onboarding.personalPlan.plan.planExpires')} {plan_end_days}.{' '}
                        {t('onboarding.personalPlan.plan.harged')} {subTitle}{' '}
                        {t('onboarding.personalPlan.plan.for')} {title},{' '}
                        {t('onboarding.personalPlan.plan.then')} {price}.{' '}
                        {t('onboarding.personalPlan.plan.last')}
                      </span>
                    )} */}
        <div className={styles.noPayment}>
          <CheckGrayIcon />
          <Caption size='xs'>{getLocalizedText(paywall.noPayment, locale)}</Caption>
        </div>
        <div className={styles.overlay}></div>
      </div>
      <div className={styles.bottomTextContainer}>
        <p className={styles.bottomText}>
          {formatPriceInText(getLocalizedText(paywall.bottomText, locale), price)}{' '}
          <span className={styles.privacy}>
            {t('onboarding.paywall.privacy')}{' '}
            <a onClick={() => setPage('privacy-policy')}>
              {t('onboarding.personalPlan.plan.privacy')}
            </a>{' '}
            {t('onboarding.paywall.and')}{' '}
            <a onClick={() => setPage('terms-of-use')}>{t('onboarding.personalPlan.plan.terms')}</a>
          </span>
        </p>
      </div>
      {showEmailPopup && <EmailPopup isOpen={isEmailPopupOpen} onClose={handleEmailPopupClose} />}
    </>
  );
};

export default Paywall;
